import React, { useState } from 'react';

import TextSearchInput from 'components/common/TextSearchInput/textSearchInput';

import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/style/table.module.scss';

export const SearchFilter = ({ ui }) => {
    const [search, setSearch] = useState<string>(ui.state.search ?? '');

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
            ui.setters.setSearch(search);
        }
    };

    const handleClear = () => {
        setSearch('');
        ui.setters.setSearch('');
    };

    return (
        <TextSearchInput
            placeholder="Search Risks by Name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            handleClear={handleClear}
            maxLength={200}
            handleClick={() => ui.setters.setSearch(search)}
            onKeyDown={onKeyDown}
            className={classes.textInput}
        />
    );
};
